import { ESortValue } from '../../../../packages/api-models/common/json_query';
import { EKey } from '../../repositories/dailyrent/entities/sort_variant/SortVariant';

export type TSortKey = EKey;

const SORT_KEY_TO_ESORT_VALUE: Readonly<Record<TSortKey, ESortValue>> = {
  area: ESortValue.Area,
  default: ESortValue.Default,
  landArea: ESortValue.LandArea,
  mkad: ESortValue.MKAD,
  price: ESortValue.Price,
  squarePrice: ESortValue.SquarePrice,
  streetName: ESortValue.StreetName,
  walkingTime: ESortValue.WalkingTime,
};

const ESORT_VALUE_TO_SORT_KEY: Readonly<Partial<Record<ESortValue, TSortKey>>> = Object.keys(
  SORT_KEY_TO_ESORT_VALUE,
).reduce<Partial<Record<ESortValue, TSortKey>>>((acc, key) => {
  const sortKey = key as TSortKey;
  acc[SORT_KEY_TO_ESORT_VALUE[sortKey]] = sortKey;

  return acc;
}, {});

export const toESortValue = (sortKey: TSortKey): ESortValue => SORT_KEY_TO_ESORT_VALUE[sortKey];

export const fromESortValue = (value: ESortValue): TSortKey => ESORT_VALUE_TO_SORT_KEY[value] ?? EKey.Default;
